import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  undefined: {
    id: 'studio.eVrDft',
    defaultMessage: 'No value',
  },
  null: {
    id: 'studio.aruNNm',
    defaultMessage: 'Null',
  },
  emptyString: {
    id: 'studio.Ma39yN',
    defaultMessage: 'Empty string',
  },
  whitespace: {
    id: 'studio.vdaySH',
    defaultMessage: 'Whitespace',
  },
});
